var map = {
	"./Betachon_logo.jpg": 617,
	"./Betachon_logo.webp": 243,
	"./OnTrac.jpeg": 635,
	"./Paecel Force.jpeg": 481,
	"./Royal Mail.jpeg": 290,
	"./Tnt.jpeg": 478,
	"./Ups.jpeg": 306,
	"./Yodel.jpeg": 109,
	"./canadapost.png": 191,
	"./dhl.png": 451,
	"./fedex.png": 713,
	"./login_front.png": 432,
	"./logo.png": 374,
	"./purolator.png": 627,
	"./ups.png": 901,
	"./usps.png": 460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 467;